import { useRef, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Camera, CheckCircle2 } from "lucide-react";

export function EquipmentTick({ contract, onChanged }) {
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const v = contract.equipment_validated;
  const toggle = async () => {
    setBusy(true);
    try { await api.post(`/trial-integration/equipment/validate/${contract.id}`, { validated: !v?.validated }); toast.success(!v?.validated ? "Équipement validé ✔" : "Validation retirée"); onChanged?.(); }
    catch { toast.error("Échec"); }
    setBusy(false);
  };
  const upload = async (f) => {
    if (!f) return; setBusy(true);
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/trial-integration/equipment/photo/${contract.id}`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Photo du kit enregistrée et envoyée à la famille"); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Upload impossible"); }
    setBusy(false);
  };
  return (
    <div className="flex items-center justify-center gap-1.5" data-testid={`equip-cell-${contract.id}`}>
      <button onClick={toggle} disabled={busy} data-testid={`equip-tick-${contract.id}`} title={v?.validated ? `Validé par ${v.by?.name || "—"} le ${(v.at || "").slice(0, 10)}${v.note ? " · " + v.note : ""}` : "Cocher après la vérification de 2 minutes au dojo"}
        className={`inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-md border ${v?.validated ? "border-[#10b981]/50 text-[#10b981] bg-[#10b981]/10" : "border-white/15 text-white/50 hover:text-white"}`}>
        <CheckCircle2 size={12} /> {v?.validated ? "Validé" : "À valider"}</button>
      <button onClick={() => fileRef.current?.click()} disabled={busy} title="Photo du kit validé (envoyée aux parents)" data-testid={`equip-photo-${contract.id}`}
        className={`p-1 rounded-md border ${v?.photo_url ? "border-[#C9A961]/60 text-[#C9A961]" : "border-white/15 text-white/40 hover:text-white"}`}><Camera size={12} /></button>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`equip-photo-input-${contract.id}`} />
      {v?.photo_url && <a href={v.photo_url.startsWith("http") ? v.photo_url : `${process.env.REACT_APP_BACKEND_URL}${v.photo_url}`} target="_blank" rel="noreferrer" className="text-[10px] text-[#C9A961] underline">photo</a>}
    </div>
  );
}
